// VIP 12 - Page 6: Hemodynamics
// 6-1. 2min before REBOA insertion
// 6-2. 1min before REBOA insertion
// 6-3. 1min after REBOA insertion
// 6-4. 2min after REBOA insertion
// 6-5. 4min after REBOA insertion
// 6-6. 10min after REBOA insertion

import React from "react";

const Page6 = ({ formData, handleChange, handleCheckboxChange, dtDisplay }) => {
  // 텍스트 입력 필드 렌더링 함수 (1열 레이아웃용)
  const renderTextField1Col = (
    fieldName,
    label,
    placeholder = "",
    unit = "",
    isRequired = false,
    type = "text"
  ) => {
    return (
      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">
            {label}
            {isRequired && <span className="required-mark"> *</span>}
          </label>
          <div className="input_1col">
            <input
              type={type}
              name={fieldName}
              placeholder={placeholder}
              value={formData[fieldName] || ""}
              onChange={handleChange}
            />
            {unit && <span className="unit-text">{unit}</span>}
          </div>
        </div>
      </div>
    );
  };

  // 혈역학적 파라미터 섹션 렌더링 함수
  const renderHemodynamicSection = (timePoint, prefix) => {
    return (
      <fieldset className="basic-info-fieldset">
        <legend>{timePoint}</legend>

        {renderTextField1Col(`sbp_${prefix}`, "SBP")}
        {renderTextField1Col(`dbp_${prefix}`, "DBP")}
        {renderTextField1Col(`mbp_${prefix}`, "MBP")}
        {renderTextField1Col(`hr_${prefix}`, "HR")}
        {renderTextField1Col(`rr_${prefix}`, "RR")}
        {renderTextField1Col(`spo2_${prefix}`, "SPO2")}
        {renderTextField1Col(`cvp_${prefix}`, "CVP")}
        {renderTextField1Col(`etco2_${prefix}`, "ETCO2")}
        {renderTextField1Col(`bt_${prefix}`, "BT")}
      </fieldset>
    );
  };

  return (
    <section className="vip-form-section">
      <h2 className="section-subtitle">Hemodynamics</h2>

      {/* 6-1. 2min before REBOA insertion */}
      {renderHemodynamicSection("6-1. 2min before REBOA insertion", "pre_2min")}

      {/* 6-2. 1min before REBOA insertion */}
      {renderHemodynamicSection("6-2. 1min before REBOA insertion", "pre_1min")}

      {/* 6-3. 1min after REBOA insertion */}
      {renderHemodynamicSection(
        "6-3. 1min after REBOA insertion",
        "after_1min"
      )}

      {/* 6-4. 2min after REBOA insertion */}
      {renderHemodynamicSection(
        "6-4. 2min after REBOA insertion",
        "after_2min"
      )}

      {/* 6-5. 4min after REBOA insertion */}
      {renderHemodynamicSection(
        "6-5. 4min after REBOA insertion",
        "after_4min"
      )}

      {/* 6-6. 10min after REBOA insertion */}
      {renderHemodynamicSection(
        "6-6. 10min after REBOA insertion",
        "after_10min"
      )}
    </section>
  );
};

export default Page6;
